import { render, staticRenderFns } from "./AgentVanColl.vue?vue&type=template&id=88d3207e&scoped=true"
import script from "./AgentVanColl.vue?vue&type=script&lang=js"
export * from "./AgentVanColl.vue?vue&type=script&lang=js"
import style0 from "./AgentVanColl.vue?vue&type=style&index=0&id=88d3207e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d3207e",
  null
  
)

export default component.exports